/*******************************************************************************
 * Copyright (c) 2026 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {VerifyType} from '@shared/modules/auth/models/verify-type';

export interface SetupMfaRequest {
  type: VerifyType;
  mobilePhoneNumber?: string;
}

export interface SetupMfaApiRequest {
  type: VerifyType;
  mobile_phone_number?: string;
}

export interface SetupMfaResponse {
  type: VerifyType;
  provisioningUri?: string;
}

export interface SetupMfaApiResponse {
  type: VerifyType;
  provisioning_uri?: string;
}

export const setupMfaToApiRequest = (request: SetupMfaRequest): SetupMfaApiRequest => ({
  type: request.type,
  ...(request.mobilePhoneNumber && {mobile_phone_number: request.mobilePhoneNumber}),
});

export const setupMfaFromApiResponse = (response: SetupMfaApiResponse): SetupMfaResponse => ({
  type: response.type,
  ...(response.provisioning_uri && {provisioningUri: response.provisioning_uri}),
});
